import { Controller } from "@hotwired/stimulus"

// Re-renders the page once a running step passes its "stalled" time, so an open
// page swaps a stuck "Working…" button for the retry without a manual reload.
export default class extends Controller {
  // Milliseconds until the run counts as stalled, computed by the server so a
  // skewed browser clock cannot trigger early (or repeated) refreshes.
  static values = { in: Number }

  connect() {
    const delay = Math.max(this.inValue, 0) + 1000
    this.timer = setTimeout(() => this.refresh(), delay)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    window.Turbo.visit(window.location.href, { action: "replace" })
  }
}
